/*!
 * hoverIntent v1.8.0 // 2014.06.29 // jQuery v1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007, 2014 Brian Cherne
 */
(function($){$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var cfg={interval:100,sensitivity:6,timeout:0};if(typeof handlerIn==="object"){cfg=$.extend(cfg,handlerIn)}else{if($.isFunction(handlerOut)){cfg=$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector})}else{cfg=$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut})}}var cX,cY,pX,pY;var track=function(ev){cX=ev.pageX;cY=ev.pageY};var compare=function(ev,ob){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);if(Math.sqrt((pX-cX)*(pX-cX)+(pY-cY)*(pY-cY))<cfg.sensitivity){$(ob).off("mousemove.hoverIntent",track);ob.hoverIntent_s=true;return cfg.over.apply(ob,[ev])}else{pX=cX;pY=cY;ob.hoverIntent_t=setTimeout(function(){compare(ev,ob)},cfg.interval)}};var delay=function(ev,ob){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t);ob.hoverIntent_s=false;return cfg.out.apply(ob,[ev])};var handleHover=function(e){var ev=$.extend({},e);var ob=this;if(ob.hoverIntent_t){ob.hoverIntent_t=clearTimeout(ob.hoverIntent_t)}if(e.type==="mouseenter"){pX=ev.pageX;pY=ev.pageY;$(ob).on("mousemove.hoverIntent",track);if(!ob.hoverIntent_s){ob.hoverIntent_t=setTimeout(function(){compare(ev,ob)},cfg.interval)}}else{$(ob).off("mousemove.hoverIntent",track);if(ob.hoverIntent_s){ob.hoverIntent_t=setTimeout(function(){delay(ev,ob)},cfg.timeout)}}};return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}})(jQuery);

// On Idle
(function(){"use strict";window.idle=function(options){var defaults={idle:6e4,events:["mousemove","keydown","mousedown","touchstart"],onIdle:function(){},onActive:function(){},onHide:function(){},onShow:function(){},keepTracking:true,startAtIdle:false,recurIdleCall:false};var settings=extend({},defaults,options);var idle=settings.startAtIdle;var visible=!settings.startAtIdle;var visibilityEvents=["visibilitychange","webkitvisibilitychange","mozvisibilitychange","msvisibilitychange"];var lastId=null;var resetTimeout,timeout;window.addEventListener("idle:stop",function(event){bulkRemoveEventListener(window,settings.events);settings.keepTracking=false;resetTimeout(lastId,settings)});var resetTimeout=function resetTimeout(id,settings){if(idle){idle=false;settings.onActive.call()}clearTimeout(id);if(settings.keepTracking){return timeout(settings)}};var timeout=function timeout(settings){var timer=settings.recurIdleCall?setInterval:setTimeout;var id;id=timer(function(){idle=true;settings.onIdle.call()},settings.idle);return id};return{start:function(){lastId=timeout(settings);bulkAddEventListener(window,settings.events,function(event){lastId=resetTimeout(lastId,settings)});if(settings.onShow||settings.onHide){bulkAddEventListener(document,visibilityEvents,function(event){if(document.hidden||document.webkitHidden||document.mozHidden||document.msHidden){if(visible){visible=false;settings.onHide.call()}}else{if(!visible){visible=true;settings.onShow.call()}}})}}}};var bulkAddEventListener=function bulkAddEventListener(object,events,callback){events.forEach(function(event){object.addEventListener(event,function(event){callback(event)})})};var bulkRemoveEventListener=function bulkRemoveEventListener(object,events){events.forEach(function(event){object.removeEventListener(event)})};var extend=function extend(out){out=out||{};for(var i=1;i<arguments.length;i++){if(!arguments[i]){continue}for(var key in arguments[i]){if(arguments[i].hasOwnProperty(key)){out[key]=arguments[i][key]}}}return out}})();

function closeDesktopMenu() {
	var $menu = $('#menu');
	var menuli = $("#main-menu li a.hassubmenu");
	menuli.removeClass('active');
	$menu.removeClass('opened').find('.wrapper > grid--full').hide();
	$menu.find('.topmenu').hide();
}

function disableSocialProof() {
	$('.social-proof-popup').remove(); 
	Cookies2.set('hide-social-proof', true, { expires: 30 }); 
	return false;
}

function activateSocialOffer(url, offertext) {
	var grinderoffer = $("#freegrinder.collapsed");
	grinderoffer.hoverIntent(function() {
		$.getScriptOnce('//www.smokecartel.com/cdn/shop/t/38/assets/social-locker.js?v=27896168687548526821733865493', function() {
			grinderoffer.removeClass('collapsed');
			
			$('#freegrinder-locker').sociallocker({
				text: {
					header: "",
					message: "",	
				},
				facebook: {
					appId: "878832968796627"
				},
				twitter: {
					tweet: {
						url: url,
						via: 'smokecartel',
						text: offertext,
					}
				},
				google: { 
					plus: {
						url: url,
					}
				},
				url: url,
				buttons: {
					order: ["facebook-share", "twitter-tweet", "google-share", "linkedin-share"],
				},
			});
			
			$('#freegrinder-locker a.btn').click(function(event) {
				event.preventDefault();
				Shopify.addItem($('#freegrinder-option').val(), 1, function() {
					$('#freegrinder .freegrinder-content').html('<h2>Woot!  Free Item Added!</h2><p style="margin-bottom: 20px;">Your free item is now in your cart.  To checkout, complete your purchase with an eligble item of $10 or more.</p>');
				});
				return false;
			});
		});
	});
}

function initDesktop() {
	var $menu = $('#menu');
	var menuli = $("#main-menu li a.hassubmenu");
	
	menuli.click(function(event) {
		event.preventDefault();		
		if($(this).hasClass('active')) {
			closeDesktopMenu();
		}
		else {
			if($("#main-menu li a.active").length > 0) { closeDesktopMenu(); }
			
			$(this).show().addClass('active');
			var menu = $(this).attr('href');
			$(menu).show().parent().parent().addClass('opened');
		}
	});
	
	$menu.hoverIntent({
		over: function() {},
		out: closeDesktopMenu,
		timeout: 200
	});
	
	var focus_interval;
	var message_1 = "👋 Hey bud! Still here?";
	var message_2 = "🙏 We miss you! - Smoke Cartel";
	var cart_message_1 = "🔥 Don't forget your items!";
	var cart_message_2 = "🛒 We're holding your cart!";
	var show_message_1 = message_1;
	var show_message_2 = message_2;
	var original_title = document.title;
	var hascart = false;
	
	$(window).focus(function() {
		Cookies2.set('tab_focus', 'on', { expires: 1 });
						
		if(original_title) {
			document.title = original_title;
		}
		
		if(CartCount.html() != '' && CartCount.html() > 0) {
			Tinycon.setOptions({
				color: '#ffffff',
				background: '#22a358',
			});
			Tinycon.setBubble(CartCount.html());
		}
		
		clearInterval(focus_interval);
	}).blur(function() {
		Cookies2.set('tab_focus', 'off', { expires: 1 });
		if(!document.hidden) {
			Cookies2.set('tab_focus', 'on', { expires: 1 });
		}
				
		// If has cart, show different message
		if(CartCount.html() != '' && CartCount.html() > 0) {
			show_message_1 = cart_message_1;
			show_message_2 = cart_message_2;
			hascart = true;
		}
		else {
			show_message_1 = message_1;
			show_message_2 = message_2;
			hascart = false;
		}
				
		document.title = show_message_1;
		focus_interval = setInterval(function() {
			if(!document.hidden) {
				Cookies2.set('tab_focus', 'on', { expires: 1 });
			}
											
			if(Cookies2.get('tab_focus') == 'off') {
				if(document.title == show_message_1) {
					document.title = show_message_2;
					
					if(hascart) {
						Tinycon.setOptions({
							color: '#ffffff',
							background: '#22a358',
						});
						Tinycon.setBubble(CartCount.html());
					}
				}
				else if(document.title == show_message_2) {
					document.title = original_title;
				}
				else {
					document.title = show_message_1;
					
					if(hascart) {
						Tinycon.setOptions({
							color: '#22a358',
							background: '#ffffff',
						});
						Tinycon.setBubble(CartCount.html());
					}
				}
			}
			else {
				document.title = original_title;
			}
		}, 2000);
	});
	
	window.onunload = function() {
		Cookies2.set('tab_focus', 'off', { expires: 1 });
	};
	
	function showSocialProof() {
		if($('.social-proof-popup').length > 0) {
			var $sp = $('.social-proof-popup:first');
			if($('#animation-css').length > 0) {
				$sp.show().delay(7000).fadeOut(250, function() {
					$(this).remove();
				});
			}
			else {
				$sp.fadeIn(300).delay(7000).fadeOut(250, function() {
					$(this).remove();
				});
			}
			$sp.hover(function() {
				$(this).stop();
			}, function() {
				$(this).delay(3000).fadeOut(250, function() {
					$(this).remove();
				});
			});
		}
	}
	
	idle({
		onIdle: function (){
			if(!document.hidden && Cookies2.get('hide-social-proof') == null || typeof Cookies2.get('hide-social-proof') == 'undefined') {
				showSocialProof();
			}
		},
		onActive: function() {
			if(!document.hidden && Cookies2.get('hide-social-proof') == null || typeof Cookies2.get('hide-social-proof') == 'undefined') {
				showSocialProof();
			}
		},
		idle: 10000
	}).start();
}